import React from "react";
import "./BsdmPage.css";
import BannerImage from "../Component/Bsdm.jpg"; // ✅ Replace with your actual image name

const BsdmPage = () => {
  return (
    <div className="bsdm-page">
      {/* 🔹 Banner Section */}
      <div className="bsdm-banner">
        <img src={BannerImage} alt="BSDM Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 bsdm-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About BSDM (Bihar Skill Development Mission)
        </h2>

        <p>
          The Bihar Skill Development Mission (BSDM) is a transformative initiative launched by the
          Government of Bihar to equip the state’s youth with modern, employable skills and improve
          their career prospects. As an approved training partner, CPIT actively supports BSDM’s
          vision by offering quality skill-based education that bridges the gap between academic
          learning and industry requirements.
        </p>

        <p>
          BSDM focuses on creating an ecosystem that promotes technical, digital, and vocational
          education for all. At CPIT, BSDM-certified programs are carefully designed to match current
          market demands, ensuring that students gain relevant expertise in areas such as
          Information Technology, Communication, Accounting, and Business Management. The courses
          integrate hands-on training with theoretical knowledge, allowing learners to develop both
          technical skills and confidence.
        </p>

        <p>
          Through BSDM, CPIT emphasizes practical learning experiences, including workshops,
          real-world projects, and interactive sessions with industry professionals. This approach
          not only enhances employability but also nurtures leadership, teamwork, and problem-solving
          abilities—key traits that employers look for in today’s competitive job market.
        </p>

        <p>
          Upon successful completion of BSDM programs, students receive government-recognized
          certifications that significantly enhance their job opportunities in both the private and
          public sectors. The initiative has played a vital role in empowering thousands of young
          individuals across Bihar, helping them achieve financial independence and contribute to the
          state’s socio-economic growth.
        </p>
      </div>
    </div>
  );
};

export default BsdmPage;
